import React from "react";
import ReactDOM from "react-dom";
import smoothscroll from "smoothscroll-polyfill";
import App from "./views/App";
import "./index.less";

import 'array-flat-polyfill';

smoothscroll.polyfill();

ReactDOM.render(<App />, document.getElementById("root"));
